// extracted by mini-css-extract-plugin
export default {"counter":"counter_counter__UGwMY","counterInput":"counter_counterInput__i9yE3","actionbutton":"counter_actionbutton__7kd0O"};